import React, { useContext } from 'react'
import { FormSection } from '@cicero/ui'
import { StoreContext } from 'models'

export const UserSettings = () => {
  const store = useContext(StoreContext)

  return <FormSection title="User Profile">
    <p><strong>Name:</strong> {store.session?.user.first_name} {store.session?.user.last_name}</p>
    <p><strong>Email:</strong> {store.session?.user.email}</p>
  </FormSection>
}
